<template>
<div class="hello">
<!--Container-->
<div class="container w-full md:max-w-3xl mx-auto pt-20">
  <div class="w-full px-4 md:px-6 text-xl text-gray-800 leading-normal" style="font-family:Georgia,serif;">
    <!--Title-->
			<div class="font-sans">
						<h1 class="font-bold font-sans break-normal text-gray-900 pt-6 pb-2 text-3xl md:text-4xl">Políticas de privacidad</h1>
						<p class="text-sm md:text-base font-normal text-gray-600">Published 2014</p>
			</div>
      <h1 class="py-2 font-sans font-bold">Aviso de Privacidad</h1>
<p class="py-6">
	ZESTY IEDS S.A. DE C.V. que en lo subsecuente se le denominará “ZESTY”, con domicilio en Carretera internacional,<br>
	K.M., 5.5, local 36, Colonia Parque Industrial de Nogales, Heroica Nogales, Sonora, hace de su conocimiento lo siguiente:
</p>
<p class="py-6">
	“ZESTY”, es responsable de la recolección y manejo de los datos personales y para estos efectos cumple con todos los
	requerimientos estipulados por la ley. De manera particular más no exclusiva se cumplen con los principios que incluyen
	licitud, calidad, seguridad, consentimiento y responsabilidad.
</p>
<h2 class="py-2 font-sans font-bold">
	Fuente de Datos Personales
</h2>
<p class="py-6">
	“ZESTY”, hace de su conocimiento que sus datos pueden ser recabados por los siguientes medios:
</p>
<ul>
	<li class="py-3">
		De manera directa y personal en nuestras oficinas con el domicilio anteriormente mencionado.
	</li>
	<li class="py-3">
		Vía telefónica.
	</li>
	<li class="py-3">
		Vía nuestra página de Internet www.zesty.com.mx
	</li>
	<li class="py-3">
		Formas de Contacto físicas, distribuidas en conferencias, eventos y demás actividades promocionales.
	</li>
</ul>
<h2 class="py-2 font-sans font-bold">
	Datos Personales a Recabar
</h2>
<p class="py-6">
	De igual manera hacemos de su conocimiento que podremos recopilar los siguientes datos de manera directa, telefónica
	o en nuestro sitio web:
</p>
<ul>
	<li class="py-3">
		Nombre Completo y/o Razón Social
	</li>
	<li class="py-3">
		Ocupación
	</li>
	<li class="py-3">
		Fecha de Nacimiento
	</li>
	<li class="py-3">
		Domicilio Completo Fiscal y/o Particular
	</li>
	<li class="py-3">
		Teléfono (Particular y/o celular y/o radio)
	</li>
	<li class="py-3">
		Registro Federal de Contribuyentes
	</li>
	<li class="py-3">
		Correo Electrónico personal y/o empresarial
	</li>
	<li class="py-3">
		IFE
	</li>
	<li class="py-3">
		Sexo
	</li>
	<li class="py-3">
		Firma
	</li>
</ul>
<p class="py-6">
	Con el objetivo de realizar operaciones financieras se pueden solicitar los siguientes datos de manera adicional:
</p>
<ul>
	<li class="py-3">
		No. De Cuenta Bancaria
	</li>
	<li class="py-3">
		No. De Tarjeta de Débito y/o Crédito
	</li>
	<li class="py-3">
		Clabe Interbancaria
	</li>
</ul>
<p class="py-6">
	Con el objetivo de brindar el servicio de entrega a domicilio, “ZESTY” podrá recabar:
</p>
<ul>
	<li class="py-3">
		Ubicación
	</li>
</ul>
<p class="py-6">
	Los datos que podemos recabar cuando visita nuestro sitio de internet o utiliza nuestros servicios en línea son los
	siguientes: Dirección IP, tipo de navegador del usuario, el nombre de dominio y páginas dentro del sitio a través de las
	cuales se tuvo acceso, duración del tiempo de interacción en la página de internet de “ZESTY”, todo esto mediante el
	uso de cookies y web beacons, mismas que pueden ser deshabilitadas en su navegador. Para realizar este procedimiento
	contacte al fabricante de su navegador.
</p>
<h2 class="py-2 font-sans font-bold">
	Usos de los Datos
</h2>
<p class="py-6">
	Los datos a recopilar anteriormente serán utilizados para los siguientes propósitos:
</p>
<h2 class="py-2 font-sans font-bold">
	REQUERIDOS PARA PROPORCIONAR EL SERVICIO CONTRATADO:
</h2>
<ul>
	<li class="py-3">
		Otorgar los servicios contratados
	</li>
	<li class="py-3">
		Confirmar y/o asignar citas para servicios
	</li>
	<li class="py-3">
		Trámites de facturación
	</li>
	<li class="py-3">
		Actividades de Archivo y Respaldo de Información
	</li>
	<li class="py-3">
		“ZESTY”, recoge datos de ubicación para habilitar la función de servicio de entrega a domicilio, mientras la
		aplicación esté en uso o un pedido a domicilio esté pendiente de entrega.
	</li>
</ul>
<h2 class="py-2 font-sans font-bold">
	NO NECESARIOS PARA PROPORCIONAR EL SERVICIO CONTRATADO:
</h2>
<ul>
	<li class="py-3">
		Manejo de programas de lealtad para clientes.
	</li>
	<li class="py-3">
		Realizar Rifas y/o concursos
	</li>
	<li class="py-3">
		Envío de comunicaciones y/o imágenes promocionales de productos y servicios
	</li>
</ul>
<h2 class="py-2 font-sans font-bold">
	Derechos ARCO
</h2>
<p class="py-6">
	Usted tiene derecho a Acceder a sus datos personales que poseemos y al detalle de los tratamientos de los mismos,
	Rectificarlos en caso de que sean inexactos o incompletos, Cancelarlos cuando considere que no se requieren para
	alguna de las finalidades señaladas en el presente aviso de privacidad, estén siendo utilizados para fines no consentidos,
	o haya finalizado la relación contractual o de servicio, o bien Oponerse al tratamiento de los mismos para fines específicos.
</p>
<p class="py-6">
	El mecanismo implementado para el ejercicio de los derechos de ARCO es: Mediante el formulario correspondiente que
	podrá obtener previa solicitud al correo adrian@zesty.com.mx, deberá ser llenado en su totalidad, y enviarlo al mismo
	correo electrónico adrian@zesty.com.mx acompañado de los documentos que dicha solicitud requiera.
</p>
<p class="py-6">
	Los plazos para atender su solicitud de acuerdo a lo que marca el artículo 32 de la ley serán un máximo de 20 días hábiles
	contados a partir de la fecha de recepción de la solicitud de derechos ARCO.
</p>
<h2 class="py-2 font-sans font-bold">
	Transferencia de Datos a Terceros
</h2>
<p class="py-6">
	Sus datos personales pueden ser tratados dentro y fuera del país, por personas distintas a esta empresa. En este sentido
	su información puede ser compartida con nuestros socios estratégicos en las plataformas de información con el propósito
	de:
</p>
<ul>
	<li class="py-3">
		Otorgarle el servicio solicitado.
	</li>
	<li class="py-3">
		Para el envío de correos electrónicos informativos, sorteos y promocionales.
	</li>
	<li class="py-3">
		Para la gestión de la facturación.
	</li>
	<li class="py-3">
		Para propósitos de cobranza y/o consultoría jurídica en caso de incumplimiento del pago de nuestros servicios.
	</li>
	<li class="py-3">
		Con el objetivo de respaldar y archivar la información para futura referencia.
	</li>
	<li class="py-3">
		Cumplimiento de legislaciones
	</li>
	<li class="py-3">
		Auditoría, consultoría y soporte
	</li>
	<li class="py-3">
		Prospección y recolección de evidencia
	</li>
	<li class="py-3">
		Validación en el cumplimiento de mejores prácticas
	</li>
</ul>
<h2 class="py-2 font-sans font-bold">
	Seguridad
</h2>
<p class="py-6">
	Nos comprometemos a no transferir sus datos personales sensibles, así mismo nos abstendremos de vender, arrendar o
	alquilar sus datos personales a terceros.
</p>
<p class="py-6">
	En caso de que ocurra alguna vulneración de seguridad en cualquier fase del tratamiento de sus datos personales, nos
	comprometemos a hacer del conocimiento general este hecho de manera inmediata mediante nuestra página de Internet
	www.zesty.com.mx, para que se tomen las medidas correspondientes a fin de resguardar sus derechos.
</p>
<p class="py-6">
	Si usted considera que su derecho de protección de datos personales ha sido lesionado por alguna conducta de nuestros
	empleados o de nuestras actuaciones o respuestas, presume que en el tratamiento de sus datos personales existe alguna
	violación a las disposiciones previstas por la Ley Federal de Protección de Datos Personales en Posesión de los
	Particulares, podrá interponer la queja o denuncia correspondiente. Para mayor información puede visitar la página
	www.ifai.org.mx.
</p>
<h2 class="py-2 font-sans font-bold">
	Modificaciones
</h2>
<p class="py-6">
	“ZESTY”, se reserva el derecho de efectuar modificaciones y adecuaciones al presente aviso de privacidad, para la
	atención de reformas a la misma ley, políticas internas o nuevos requerimientos para la prestación de los servicios o
	productos.
</p>
<p class="py-6">
	Estas modificaciones se darán a conocer a través de anuncios visibles en nuestro establecimiento; en nuestra página de
	internet; o se las haremos llegar al último correo electrónico que nos haya proporcionado.
</p>
  </div>
</div>
</div>
</template>

<script>
export default {
name: 'HelloWorld',
props: {
msg: String
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->